export const SESSION_TOKEN_STORAGE = {
  get: () => localStorage.getItem('sessionToken'),
}
